import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";
import { Toaster } from "sonner";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 } },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false}>
        <App />
        <Toaster position="bottom-center" toastOptions={{ className: "font-sans", style: { background: "var(--elevated)", color: "hsl(var(--foreground))", border: "1px solid hsl(var(--border))" } }} />
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
